export default "/images/69885510e4125c08ef0b7c0aaa99ea89.png";